// src/pages/AssessmentPage.jsx - Profound Philosophy
// Renders the Philosophical Profile assessment — the front door the homepage
// sells ("Discover Your Philosophical Profile · 5 min"). The component owns
// its full intro → 18 questions → results flow and feeds the Dashboard card
// and gamification on completion.
import React from 'react';
import PhilosophicalProfileAssessment from '../components/PhilosophicalProfileAssessment';

const AssessmentPage = () => (
  <div className="min-h-screen bg-gradient-to-br from-charcoal via-gunmetal to-charcoal pt-20 pb-16">
    <PhilosophicalProfileAssessment />
  </div>
);

export default AssessmentPage;
